// import _ from 'lodash'
import vm from '../main'

const internals = {}

internals.addRegion = function(region) {
    region = (({
        name,
        status,
        regionManager,
        journeyManager
    }) => {
        return {
            name,
            status,
            regionManager,
            journeyManager
        }
    })(region)

    return vm.$regionDataRepository
        .create(region)
        .then(result => {
            region = result.data
            return region
        })
        .catch(error => {
            console.error('regionService.createRegion-error:\n', error)
            throw error
        })
}

internals.updateRegion = function(region) {
    region = Object.assign({}, region)
    region = (({
        _id,
        name,
        status,
        regionManager,
        journeyManager
    }) => {
        return {
            _id,
            name,
            status,
            regionManager,
            journeyManager
        }
    })(region)

    return vm.$regionDataRepository
        .update(region._id, region)
        .then(result => {
            region = result.data
            return region
        })
        .catch(error => {
            console.error('regionUpdate.update-error:\n', error)
            throw error
        })
}

export default internals


// WEBPACK FOOTER //
// ./src/services/region.service.js